import { Trans, useTranslation } from 'react-i18next';
import CIData1 from '../../assets/ci_data_1.png';
import CIData10 from '../../assets/ci_data_10.svg';
import CIData11 from '../../assets/ci_data_11.svg';
import CIData2 from '../../assets/ci_data_2.png';
import CIData3 from '../../assets/ci_data_3.svg';
import CIData4 from '../../assets/ci_data_4.svg';
import CIData5 from '../../assets/ci_data_5.svg';
import CIData6 from '../../assets/ci_data_6.svg';
import CIData7 from '../../assets/ci_data_7.svg';
import CIData8 from '../../assets/ci_data_8.svg';
import CIData9 from '../../assets/ci_data_9.svg';
import CIDataLogoMobile from '../../assets/ci_data_logo_mobile.svg';
import CIDataMobile from '../../assets/ci_data_mobile.svg';
import CIDataMobileCha from '../../assets/ci_data_mobile_cha.svg';
import CIDataMobileEng from '../../assets/ci_data_mobile_eng.svg';
import CIDataPC from '../../assets/ci_data_pc.svg';
import CIDataPCCha from '../../assets/ci_data_pc_cha.svg';
import CIDataPCEng from '../../assets/ci_data_pc_eng.svg';
import CISection2Image1 from '../../assets/ci_section2_image1.svg';
import CISection2Image1Mobile from '../../assets/ci_section2_image1_mobile.svg';
import CISection2Image2 from '../../assets/ci_section2_image2.svg';
import CISection2Image2Mobile from '../../assets/ci_section2_image2_mobile.svg';
import CISection2Image3 from '../../assets/ci_section2_image3.svg';
import CISection2Image3Mobile from '../../assets/ci_section2_image3_mobile.svg';
import CISection2Image4 from '../../assets/ci_section2_image4.svg';
import CISection2Image4Cha from '../../assets/ci_section2_image4_cha.svg';
import CISection2Image4Eng from '../../assets/ci_section2_image4_eng.svg';
import Line2 from '../../assets/line2.png';
import { CenterLayout, HorizontalEqualLayout, HorizontalLayout, useResponsivePadding, VerticalLayout } from '../../common/common-layout';
import { H3, H7, Text4, TitleNormal } from '../../common/common-text';
import BTBox from '../../common/components/BTBox';
import i18n from '../../common/i18n/i18n';
import { pxToRem } from '../../common/utils/ConvertUtils';
import '../../css/bbpage.css';
import { useDeviceType } from '../../hooks/useDeviceType';

interface CiItemParams {
  image: string;
  lineOverlay: string;
  text: string;
}

const CISection2 = () => {
  const { t } = useTranslation();
  const { horizontal: padding } = useResponsivePadding();
  const { isMobile } = useDeviceType();
  const isEng = ['en', 'en-mobile'].includes(i18n.language);
  const isChina = ['zh', 'zh-mobile'].includes(i18n.language);

  const violations: CiItemParams[] = [
    {
      image: CIData3,
      lineOverlay: Line2,
      text: '로고의 크기를 임의로 변형하여 사용할 수 없습니다.',
    },
    {
      image: CIData4,
      lineOverlay: Line2,
      text: '로고의 서체를 임의로 변형하여 사용할 수 없습니다.',
    },
    {
      image: CIData5,
      lineOverlay: Line2,
      text: '로고의 비례를 임의로 변형하여 사용할 수 없습니다.',
    },
    {
      image: CIData6,
      lineOverlay: Line2,
      text: '로고 요소의 위치를 임의로 변형하여 사용할 수 없습니다.',
    },
    {
      image: CIData7,
      lineOverlay: Line2,
      text: '로고를 임의로 축약하여 사용할 수 없습니다.',
    },
    {
      image: CIData8,
      lineOverlay: Line2,
      text: '규정된 요소 외에 요소를 임의로 추가할 수 없습니다.',
    },
    {
      image: CIData9,
      lineOverlay: Line2,
      text: '로고 컬러를 임의적으로 변경할 수 없습니다.',
    },
    {
      image: CIData10,
      lineOverlay: Line2,
      text: '로고 컬러를 임의적으로 변경할 수 없습니다. ',
    },
    {
      image: CIData11,
      lineOverlay: Line2,
      text: '로고 컬러를 임의적으로 변경할 수 없습니다. ',
    },
  ];

  const createCiItem = ({ image, lineOverlay, text }: CiItemParams) => (
    <div style={{ position: 'relative', backgroundColor: '#F5F5F5', height: pxToRem(354) }}>
      <CenterLayout style={{ height: '100%' }}>
        <img src={image} />
      </CenterLayout>

      <img
        src={lineOverlay}
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          width: '100%',
          height: '100%',
          objectFit: 'fill',
          pointerEvents: 'none',
        }}
      />

      <p
        style={{
          position: 'absolute',
          bottom: '20px',
          width: '100%',
          textAlign: 'center',
          fontSize: '18px',
          color: '#333',
          padding: '4px 8px',
        }}
      >
        {t(text)}
      </p>
    </div>
  );

  return (
    <VerticalLayout paddingLeft={padding} paddingRight={padding} paddingTop={isMobile ? 40 : pxToRem(108)} >
      <H3><Trans i18nKey='기술의 신뢰를 상징하는 이름, 비비테크' /></H3>
      <BTBox height={isMobile ? isEng ? 40 : 60 : pxToRem(110)} />
      {isMobile ?
        <VerticalLayout>
          <H7>Corporate Identity</H7>
          <BTBox height={isMobile ? 16 : 4} />
          <VerticalLayout width='100%'>
            <img src={CISection2Image1Mobile} style={{width: '100%'}} />
            {/* <CenterLayout backgroundColor='#14B446' width='100%' style={{ aspectRatio: '328/194' }}>
              <img src={CISection2Image1} style={{ width: '110px', height: '111px' }} />
            </CenterLayout> */}
            <BTBox height={16} />
            <Text4 style={{ opacity: '0.5',
              ...isChina ? {wordBreak: 'break-word'} : {} 
             }}>
              <Trans i18nKey="BBTECH의 CI는 정밀함과 신뢰를 바탕으로 한 기술 리더십을 상징합니다. 로고의 간결한 형태와 절제된 컬러는 반도체 설비 분야에서의 전문성과 안정성을 시각적으로 표현하며, 끊임없이 진화하는 산업 환경 속에서도 변함없는 가치를 제공하겠다는 비비테크의 의지를 담고 있습니다. 일관된 브랜드 아이덴티티 형성을 위해 다음 규정을 엄격히 준수하며, 임의의 형태로 변형할 수 없습니다." />
            </Text4>
          </VerticalLayout>
        </VerticalLayout>
        :
        <HorizontalLayout>
          <H7>Corporate Identity</H7>
          <VerticalLayout style={{ flex: 1 }} />
          <VerticalLayout style={{width: '61.8%'}}>
            <CenterLayout backgroundColor='#14B446' style={{width: '100%', aspectRatio: '925/499'}}>
              <img src={CISection2Image1} />
            </CenterLayout>
            <BTBox height={50} />
            <Text4 style={{ opacity: '0.5' }}>
              <Trans i18nKey="BBTECH의 CI는 정밀함과 신뢰를 바탕으로 한 기술 리더십을 상징합니다. 로고의 간결한 형태와 절제된 컬러는 반도체 설비 분야에서의 전문성과 안정성을 시각적으로 표현하며, 끊임없이 진화하는 산업 환경 속에서도 변함없는 가치를 제공하겠다는 비비테크의 의지를 담고 있습니다. 일관된 브랜드 아이덴티티 형성을 위해 다음 규정을 엄격히 준수하며, 임의의 형태로 변형할 수 없습니다." />
            </Text4>
          </VerticalLayout>
        </HorizontalLayout>
      }

      <BTBox height={isMobile ? 60 : pxToRem(200)} />

      {isMobile ?
        <HorizontalEqualLayout>
          <VerticalLayout>
            <H7>{t('CI 영문')}</H7>
            <BTBox height={8} />
            <img src={CISection2Image2Mobile} style={{ width: `100%` }} />
            {/* <CenterLayout height={60} backgroundColor='#14B446'>
              
            </CenterLayout> */}
          </VerticalLayout>
          <VerticalLayout>
            <H7>{t('CI 국문')}</H7>
            <BTBox height={8} />
            <img src={CISection2Image3Mobile} style={{ width: `100%` }} />
            {/* <CenterLayout height={60} backgroundColor='#003C1E'>
              <img src={CISection2Image3} style={{ width: '97px', height: '13px' }} />
            </CenterLayout> */}
          </VerticalLayout>
        </HorizontalEqualLayout>
        :
        <HorizontalLayout>
          <VerticalLayout>
            <H7>{t('CI 영문')}</H7>
            <BTBox height={pxToRem(20)} />
            <CenterLayout backgroundColor='#14B446' style={{ aspectRatio: '780 / 238' }}>
              <img src={CISection2Image2} style={{width: pxToRem(416)}}/>
            </CenterLayout>
          </VerticalLayout>
          <VerticalLayout>
            <H7>{t('CI 국문')}</H7>
            <BTBox height={pxToRem(20)} />
            <CenterLayout backgroundColor='#003C1E' style={{ aspectRatio: '780 / 238' }}>
              <img src={CISection2Image3} style={{width: pxToRem(385)}}/>
            </CenterLayout>
          </VerticalLayout>
        </HorizontalLayout>
      }

      <BTBox height={isMobile ? 60 : 200} />
      <H7>Color</H7>
      <BTBox height={isMobile ? 8 : pxToRem(20)} />

      {isMobile ?
        <VerticalLayout>
          <HorizontalEqualLayout gap={16}>
            <VerticalLayout style={{ border: '0.5px solid #00000088', }}>
              <VerticalLayout height={80} backgroundColor='#14B446' />
              <VerticalLayout height={0.5} backgroundColor='#00000088' />
              <TitleNormal fontSize={10} style={{ padding: '14px', lineHeight: '16px' }}>
                <strong>RGB</strong> 20 / 180 / 70<br />
                <strong>CMYK</strong> 80 / 0 / 100 / 0
              </TitleNormal>
            </VerticalLayout >
            <VerticalLayout style={{ border: '0.5px solid #00000088', }}>
              <VerticalLayout height={80} backgroundColor='#003C1E' />
              <VerticalLayout height={0.5} backgroundColor='#00000088' />
              <TitleNormal fontSize={10} style={{ padding: '14px', lineHeight: '16px' }}>
                <strong>RGB</strong> 0 / 60 / 30<br />
                <strong>CMYK</strong> 100 / 60 / 100 / 50
              </TitleNormal>
            </VerticalLayout >
          </HorizontalEqualLayout>
          <BTBox height={16} />
          <HorizontalEqualLayout gap={16}>
            <VerticalLayout style={{ border: '0.5px solid #00000088', }}>
              <VerticalLayout height={80} backgroundColor='white' />
              <VerticalLayout height={0.5} backgroundColor='#00000088' />
              <TitleNormal fontSize={10} style={{ padding: '14px', lineHeight: '16px' }}>
                <strong>RGB</strong> 255 / 255 / 255<br />
                <strong>CMYK</strong> 0 / 0 / 0 / 0
              </TitleNormal>
            </VerticalLayout >
            <VerticalLayout style={{ border: '0.5px solid #00000088', }}>
              <VerticalLayout height={80} backgroundColor='#A1A1A1' />
              <VerticalLayout height={0.5} backgroundColor='#00000088' />
              <TitleNormal fontSize={10} style={{ padding: '14px', lineHeight: '16px' }}>
                <strong>RGB</strong> 160 / 160 / 160<br />
                <strong>CMYK</strong> 0 / 0 / 0 / 50
              </TitleNormal>
            </VerticalLayout >
          </HorizontalEqualLayout>
        </VerticalLayout>
        :
        <HorizontalEqualLayout gap={pxToRem(40)}>
          <VerticalLayout style={{ border: '1px solid #00000088', }}>
            <VerticalLayout backgroundColor='#14B446' style={{ aspectRatio: '360 / 238' }} />
            <VerticalLayout height={0.5} backgroundColor='#00000088' />
            <TitleNormal fontSize={pxToRem(16)} style={{ padding: '14px', lineHeight: pxToRem(30) }}>
              <strong>RGB</strong> 20 / 180 / 70 (#14B446)<br />
              <strong>CMYK</strong> 80 / 0 / 100 / 0
            </TitleNormal>
          </VerticalLayout >
          <VerticalLayout style={{ border: '1px solid #00000088', }}>
            <VerticalLayout backgroundColor='#003C1E' style={{ aspectRatio: '360 / 238' }} />
            <VerticalLayout height={0.5} backgroundColor='#00000088' />
            <TitleNormal fontSize={pxToRem(16)} style={{ padding: '14px', lineHeight: pxToRem(30) }}>
              <strong>RGB</strong> 0 / 60 / 30 (#003C1E)<br />
              <strong>CMYK</strong> 100 / 60 / 100 / 50
            </TitleNormal>
          </VerticalLayout >
          <VerticalLayout style={{ border: '1px solid #00000088', }}>
            <VerticalLayout backgroundColor='white' style={{ aspectRatio: '360 / 238' }} />
            <VerticalLayout height={0.5} backgroundColor='#00000088' />
            <TitleNormal fontSize={pxToRem(16)} style={{ padding: '14px', lineHeight: pxToRem(30) }}>
              <strong>RGB</strong> 255 / 255 / 255 (#FFFFFF)<br />
              <strong>CMYK</strong> 0 / 0 / 0 / 0
            </TitleNormal>
          </VerticalLayout >
          <VerticalLayout style={{ border: '1px solid #00000088', }}>
            <VerticalLayout backgroundColor='#A1A1A1' style={{ aspectRatio: '360 / 238' }} />
            <VerticalLayout height={0.5} backgroundColor='#00000088' />
            <TitleNormal fontSize={pxToRem(16)} style={{ padding: '14px', lineHeight: pxToRem(30) }}>
              <strong>RGB</strong> 160 / 160 / 160 (#A0A0A0)
              <br />
              <strong>CMYK</strong> 0 / 0 / 0 / 50
            </TitleNormal>
          </VerticalLayout >
        </HorizontalEqualLayout>
      }

      <BTBox height={isMobile ? 60 : 200} />
      <H7>Clear Space</H7>
      <BTBox height={isMobile ? 8 : pxToRem(20)} />

      {isMobile ? (
        <VerticalLayout>
          <img src={CIDataLogoMobile} style={{width: '100%'}} />
          {/* <CenterLayout style={{ backgroundColor: '#F5F5F5', aspectRatio: '777 / 276' }}>
            <img src={CIData1} style={{ width: '204px', marginRight: pxToRem(60) }} />
          </CenterLayout>
          <BTBox height={4} />
          <CenterLayout style={{ backgroundColor: '#F5F5F5', aspectRatio: '777 / 276' }}>
            <img src={CIData2} style={{ width: '181px', marginRight: pxToRem(60) }} />
          </CenterLayout> */}

        </VerticalLayout>
      ) : (
        <HorizontalEqualLayout gap={16}>
          <CenterLayout style={{ backgroundColor: '#F5F5F5', aspectRatio: '777 / 276' }}>
            <img src={CIData1} style={{ width: pxToRem(484), marginRight: pxToRem(60) }} />
          </CenterLayout>
          <CenterLayout style={{ backgroundColor: '#F5F5F5', aspectRatio: '777 / 276' }}>
            <img src={CIData2} style={{ width: pxToRem(428), marginRight: pxToRem(60) }} />
          </CenterLayout>
        </HorizontalEqualLayout>
      )}

      <BTBox height={isMobile ? 8 : pxToRem(37)} />
      <Text4 style={{ opacity: 0.5 }}><Trans i18nKey='최소 공간은 브랜드 로고를 사용할 때에 최소한 지켜져야 하는 주변 여백 공간으로, 사진이나 그래픽 영역에서 해당 로고를 사용하게 될 경우에 로고가 손상되거나 침범되지 않도록 도와주는 공간입니다. 여백 공간은 모든 적용 매체에 예외 없이 적용되어야 하며 규정 사항에 변형이 있어서는 안 됩니다. 일관된 브랜드 아이덴티티 형성을 위해 다음 규정을 엄격히 준수하며, 임의의 형태로 변형할 수 없습니다.' /></Text4>
      <BTBox height={isMobile ? 60 : pxToRem(210)} />
      <H7>Incorrect Usage</H7>
      <BTBox height={isMobile ? 4 : pxToRem(10)} />
      <Text4 style={{ opacity: 0.5 }}>{t('로고의 색상, 형태, 비례의 변형은 불가하며, 반드시 다음과 같이 규정된 형태를 따라야 합니다.')}</Text4>
      <BTBox height={isMobile ? 16 : pxToRem(32)} />

      {isMobile ? (
        <>
          <img src={isEng ? CIDataMobileEng : isChina ? CIDataMobileCha : CIDataMobile} style={{width: '100%'}} />
        </>
      ) : (
        <>
          <img src={isEng ? CIDataPCEng : isChina ? CIDataPCCha : CIDataPC} style={{width: '100%'}} />
          {/* <HorizontalEqualLayout gap={1} style={{ backgroundColor: '#B3B3B3' }}>
            {createCiItem(violations[0])}
            {createCiItem(violations[1])}
            {createCiItem(violations[2])}
          </HorizontalEqualLayout>
          <VerticalLayout height={1} backgroundColor='#B3B3B3' />
          <HorizontalEqualLayout gap={1} style={{ backgroundColor: '#B3B3B3' }}>
            {createCiItem(violations[3])}
            {createCiItem(violations[4])}
            {createCiItem(violations[5])}
          </HorizontalEqualLayout>
          <VerticalLayout height={1} backgroundColor='#B3B3B3' />
          <HorizontalEqualLayout gap={1} style={{ backgroundColor: '#B3B3B3' }}>
            {createCiItem(violations[6])}
            {createCiItem(violations[7])}
            {createCiItem(violations[8])}
          </HorizontalEqualLayout> */}
        </>
      )}


      <BTBox height={isMobile ? 60 : 170} />
      {isMobile ?
        <VerticalLayout>
          <H7>Master Brand Strategy</H7>
          <BTBox height={8} />
          <Text4 style={{ flex: 1, opacity: 0.5 }}>
            <Trans i18nKey="비비테크는 패밀리 브랜드로써 자회사는 비비테크 CI를 보증자산으로 활용하고 있습니다. Master Brand Strategy (단일브랜드 전략) 단일 브랜드 전략은 기업의 대표 브랜드 (Mother Brand)를 중심으로 비즈니스 영역에 따라 파생되는 하위 브랜드들이 나누어지는 방식입니다. 이 전략은 대표 브랜드의 아이덴티티를 보증 자산으로 동일하게 활용하는 것이 특성입니다." />
          </Text4>
        </VerticalLayout>
        :
        <HorizontalLayout>
          <H7>Master Brand Strategy</H7>
          <div style={{flex: 1}}></div>
          <Text4 style={{ width: '61.8%' , opacity: 0.5 }}>
            <Trans i18nKey="비비테크는 패밀리 브랜드로써 자회사는 비비테크 CI를 보증자산으로 활용하고 있습니다. Master Brand Strategy (단일브랜드 전략) 단일 브랜드 전략은 기업의 대표 브랜드 (Mother Brand)를 중심으로 비즈니스 영역에 따라 파생되는 하위 브랜드들이 나누어지는 방식입니다. 이 전략은 대표 브랜드의 아이덴티티를 보증 자산으로 동일하게 활용하는 것이 특성입니다." />
          </Text4>
        </HorizontalLayout>
      }

      <BTBox height={isMobile ? 40 : 170} />
      <CenterLayout>
        <img src={isEng ? CISection2Image4Eng : isChina ? CISection2Image4Cha : CISection2Image4} style={{ paddingLeft: isMobile ? '0px' : isEng ? '45px' : isChina ? '0px' : '80px', width: isMobile ? '100%' : isEng ? '100%' : '85%' }} />
      </CenterLayout>
      <BTBox height={isMobile ?  148 : 200} />
    </VerticalLayout>
  );
};

export default CISection2;
